import { createRootRoute, HeadContent, Outlet } from '@tanstack/react-router';
import { GlobalLoadingIndicator } from '@/components/GlobalLoadingIndicator';
import { Toaster } from 'sonner';
import rc_favicon from '@/assets/rosario_consumo/favicon.ico';
import pa_favicon from '@/assets/pistaccesorios/favicon.ico';

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        title: import.meta.env.VITE_APP_NAME,
      },
    ],
    links: [
      {
        rel: 'icon',
        href:
          import.meta.env.VITE_APP_NAME === 'Rosario consumo'
            ? rc_favicon
            : pa_favicon,
      },
    ],
  }),
  component: () => (
    <>
      <HeadContent />
      <GlobalLoadingIndicator />
      <Toaster position='bottom-right' closeButton />
      <Outlet />
    </>
  ),
});
